import {Modal, Col, Row, Form, Spinner} from 'react-bootstrap'
import { useContext, useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify'
import { UserContext } from '../../../UserContext'
import { validateFormFields } from '../../../utils'
import {FormInput} from '../../../components/formElements/FormInput'
import CodeMaintenanceService from '../../../services/CodeMaintenanceService'
import { Typeahead } from 'react-bootstrap-typeahead'
import CommonService from '../../../services/CommonService'
import BaseService from '../../../services/BaseService'

const EditOrganization = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, organizationInfo} = props;
    const [formErrors, setFormErrors] = useState({});
    const [orgTypes, setOrgTypes] = useState([]);
    const [orgDivisions, setOrgDivisions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [orgRequest, setOrgRequest] = useState({...organizationInfo});
    const [count, setCount] = useState(0);
    const [bgcolor, setBgcolor] = useState('yellowgreen');
    const previousOrgName = organizationInfo.orgName;
    
    useEffect(()=>{
        async function fetchOrgTypes() {
            var obj = {
                msgId: "null",
                sysId: null,
                opr: "GetLookups",
                hdrStruct: null,
                queryParam: null,
                reqData: { cdiacCode: "ORGT", active: "Y" },
            };
        
            await CodeMaintenanceService.getAllCodes(obj)
            .then((res) => res)
            .then((result) => {
                const filteredList = result.data.responses[0].filter(el => el.activeInd === "Y");
                const orgTypesListNew = [];
                filteredList.forEach((orgType, i)=>{
                    let obj = {};
                    obj = orgType;
                    obj.value = orgType.cdiacCodeValueId;
                    obj.label = orgType.cdiacCodeValueDesc;
                    orgTypesListNew.push(obj);
                })
                
                setOrgTypes(orgTypesListNew);
                setIsLoading(false);
            })
        }

        async function fetchOrgDivisions() {
            var obj = {
                msgId: "null",
                sysId: null,
                opr: "GetLookups",
                hdrStruct: null,
                queryParam: null,
                reqData: { cdiacCode: "ORGD" },
            };
        
            await CodeMaintenanceService.getAllCodes(obj)
            .then((res) => res)
            .then((result) => {
                setOrgDivisions(result.data.responses[0]);
            })
        }

        fetchOrgTypes();
        fetchOrgDivisions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    const handleCommentValue = (e, key) => {
        setCount(e.target.value.length);
        const color = (e.target.value.length === 2000) ? 'orangered' : 'yellowgreen';
        setBgcolor(color);
        setOrgRequest(prevState => ({
            ...prevState, [key] : e.target.value
        }))
    };

    const handleOrgChange = (e, key) => {
        const val = (key === "orgName") ? e.target.value : (e.length ? e[0].cdiacCodeValueId : "");

        setOrgRequest(prevState => ({
            ...prevState, [key] : val
        }))
    }

    const handleOrgStatusChange = e => {
            const { name } = e.target;
            let value = e.target.value;
            setOrgRequest(prevState => ({
                ...prevState, [name]: value
            }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-organization');
        let formErrors = validateFormFields(form.elements);
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {  
            setFormErrors({});
            var obj = {
                msgId: null,
                sysId: null,
                opr: "updateOrganization",
                hdrStruct: null,
                queryParam: null,
                reqData: { 
                    "previousOrgName" : previousOrgName,
                    "organization" :{
                        "orgId": orgRequest.orgId,
                        "orgName": orgRequest.orgName,
                        "orgTypeId": orgRequest.orgTypeId,
                        "orgDivisionId": orgRequest.orgDivisionId,
                        "orgComment": orgRequest.orgComment,
                        "lastUpdateUser": CommonService.getUserName(user),
                        "activeInd": orgRequest.activeInd
                    }
                },
            };

            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0){
                        toast.error(result.data.errors[0].message);
                    }
                    else{
                        toast.success("Organization updated successfully!");
                        onModalClose();
                    }
                    
                });
        }
    }

    return (
        <>
            <Modal show={true} backdrop="static" onHide={onModalClose} style={{ 'zindex': 1000 }}>
                <Modal.Header closeButton><h3>Edit Organization</h3></Modal.Header>
                <Modal.Body>
                    <div>
                        <form id="edit-organization">
                            <Row>
                                <Col md={6} className="control">
                                    <FormInput
                                        type="text"
                                        name="orgName"
                                        label="Organization Name"
                                        value={orgRequest.orgName}
                                        isrequired="true"
                                        validations={["required"]}
                                        onChange={(e) => handleOrgChange(e, 'orgName')}
                                        maxLength="120"
                                    />
                                    {formErrors['orgName'] && <span className="error">{formErrors['orgName']}</span>}
                                </Col>

                                <Col md={6}>
                                    <label><span className="required">*</span>Organization Type</label>
                                    <Typeahead
                                        id="orgTypeId"
                                        name="orgTypeId"
                                        placeholder="Choose Org Type..."
                                        labelKey="cdiacCodeValueDesc"
                                        selected={
                                            orgTypes.filter(option =>
                                                option.cdiacCodeValueId === orgRequest.orgTypeId)
                                        }
                                        onChange={(e) => handleOrgChange(e, 'orgTypeId')}
                                        options={orgTypes}
                                        inputProps={{ 'data-validations': 'required', name: 'orgTypeId' }}
                                        isLoading={isLoading}
                                    />
                                    {formErrors['orgTypeId'] && <span className="error">{formErrors['orgTypeId']}</span>}
                                </Col>
                                <Col md={6}>
                                    <label><span className="required">*</span>Division</label>
                                    <Typeahead
                                        id="orgDivisionId"
                                        name="orgDivisionId"
                                        placeholder="Choose Org Division..."
                                        labelKey="cdiacCodeValueDesc"
                                        selected={
                                            orgDivisions.filter(option =>
                                                option.cdiacCodeValueId === orgRequest.orgDivisionId)
                                        }
                                        onChange={(e) => handleOrgChange(e, 'orgDivisionId')}
                                        options={orgDivisions}
                                        inputProps={{ 'data-validations': 'required', name: 'orgDivisionId' }}
                                    />
                                    {formErrors['orgDivisionId'] && <span className="error">{formErrors['orgDivisionId']}</span>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <label><span className="required">*</span>Active Indicator: </label>
                                    <Form.Check
                                        inline
                                        label="No"
                                        name="activeInd"
                                        value="N"
                                        type="radio"
                                        id="activeInd_0"
                                        checked={orgRequest.activeInd === 'N'}
                                        onChange={(e) => handleOrgStatusChange(e)}
                                    />
                                    <Form.Check
                                        inline
                                        label="Yes"
                                        name="activeInd"
                                        value="Y"
                                        type="radio"
                                        id="activeInd_1"
                                        checked={orgRequest.activeInd === 'Y'}
                                        onChange={(e) => handleOrgStatusChange(e)}
                                    />
                                    {formErrors['activeInd'] && <span className="error">{formErrors['activeInd']}</span>}
                                </Col>
                            </Row>
                            <Row>
                                <div>
                                    <label>Comment: </label>
                                    <div className="comments-box">
                                        <textarea name="orgComment" value={orgRequest.orgComment}
                                        id="org-comments" onChange={(e)=>handleCommentValue(e,'orgComment')}
                                        className="form-control" rows="5" maxLength="2000" placeholder="Add a comment..."/>
                                        <span style={{position: 'relative', left: '45%' , backgroundColor: bgcolor }}>{count} out of 2000 max</span>
                                    </div>
                                </div>
                            </Row>
                            <div className="btn-div">
                                <div className="fright">
                                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                                    <button className="custom-button" type="button" onClick={(e) => handleSubmit(e)}>Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditOrganization
